import { render, staticRenderFns } from "./HYGB7.vue?vue&type=template&id=24bb92bd"
import script from "./HYGB7.vue?vue&type=script&lang=js"
export * from "./HYGB7.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports